export const PlatformFileNames = {
    ENTERPRISE_CUSTOMER_FILE: 'enterpriseCustomer.json',
    SUPPLIER_REQUEST_FILE: 'supplierRequest.json',
}